import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DeleteBidderAccountModel, User } from '../models/user';
import { ChangePasswordModel } from '../models/user';
import { ChangeNewPasswordModel } from '../models/user';
import { environment } from 'src/environments/environment.local';

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<User[]>(`${environment.BASE_API_URL}/users`);
    }

    register(user: User) {
        return this.http.post(`${environment.BASE_API_URL}/users/register`, user);
    }

    delete(id: number) {
        return this.http.delete(`${environment.BASE_API_URL}/users/${id}`);
    }

    changepassword(changepwd: ChangePasswordModel) {
        // console.log(bidder);
        return this.http.post<any>(`${environment.BASE_API_URL}user/ChangePassword`, changepwd);
    }

    forgotPassword(email:string, isNew:boolean) {        
        return this.http.get(`${environment.BASE_API_URL}user/ForgotPasswordByEmail?Email=${email}&IsNew=${isNew}`);
    }

    ActivatedDeleteUser(email:string,phone:string, isNew:boolean) {        
        return this.http.get(`${environment.BASE_API_URL}user/ActivatedDeleteUser?Email=${email}&Phone=${phone}&IsNew=${isNew}`);
    }


    resetPassword(changenewpwd: ChangeNewPasswordModel) {
        if (String(changenewpwd.UserName).includes("@")) {
            return this.http.post<any>(`${environment.BASE_API_URL}user/ChangeNewPassword`,changenewpwd);
        } else {
            return this.http.post<any>(`${environment.BASE_API_URL}user/ChangeNewPasswordUsingCellPhone`,changenewpwd);
        }
    }

    deleteBidderAccount(deleteBidderAccountModel: DeleteBidderAccountModel) {
        return this.http.post(`${environment.BASE_API_URL}user/DeleteBidderAcccount`, deleteBidderAccountModel);
    }
}